/**
 * @generated SignedSource<<a9f9935fcd27cbd0860a855d22cdcc5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileNameFragment$data = {
  readonly firstName: string;
  readonly lastName: string;
  readonly " $fragmentType": "userProfileNameFragment";
};
export type userProfileNameFragment$key = {
  readonly " $data"?: userProfileNameFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileNameFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userProfileNameFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "3c8d1fba3edf9d7dbc292316a4885ccf";

export default node;
